(function () {
  var SERVER = 'https://server.reformly.com';
  var container = document.getElementById('rda');
  if (!container) return;

  var steps = container.querySelectorAll('.rda__step');
  var emailInput = container.querySelector('#rda-email');
  var otpInput = container.querySelector('#rda-otp');
  var errorEl = container.querySelector('#rda-error');
  var otpError = container.querySelector('#rda-otp-error');
  var confirmError = container.querySelector('#rda-confirm-error');
  var confirmEmail = container.querySelector('#rda-confirm-email');
  var otpSentEmail = container.querySelector('#rda-otp-sent-email');

  var sendBtn = container.querySelector('#rda-send-btn');
  var verifyBtn = container.querySelector('#rda-verify-btn');
  var deleteBtn = container.querySelector('#rda-delete-btn');
  var cancelBtn = container.querySelector('#rda-cancel-btn');
  var backBtn = container.querySelector('#rda-back-btn');

  var email = '';
  var accessToken = '';

  function showStep(name) {
    steps.forEach(function (s) {
      s.classList.toggle('active', s.dataset.step === name);
    });
  }

  function setLoading(btn, loading, text) {
    if (loading) {
      btn.disabled = true;
      btn.dataset.originalText = btn.textContent;
      btn.innerHTML = '<span class="rda__spinner"></span> ' + text;
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || text;
    }
  }

  // Step 1: Send OTP
  container.querySelector('#rda-email-form').addEventListener('submit', function (e) {
    e.preventDefault();
    email = emailInput.value.trim();
    errorEl.textContent = '';
    setLoading(sendBtn, true, 'Sending...');

    fetch(SERVER + '/auth/request-deletion-otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
      .then(function (res) {
        if (!res.ok && res.status !== 204) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            throw new Error(data.message || 'Failed to send code. Please try again.');
          });
        }
        otpSentEmail.textContent = email;
        otpInput.value = '';
        otpError.textContent = '';
        showStep('otp');
      })
      .catch(function (err) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
      })
      .finally(function () {
        setLoading(sendBtn, false, 'Send verification code');
      });
  });

  // Step 2: Verify OTP
  container.querySelector('#rda-otp-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var code = otpInput.value.trim();
    otpError.textContent = '';
    setLoading(verifyBtn, true, 'Verifying...');

    fetch(SERVER + '/auth/verify-otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, code: code })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) {
            throw new Error(data.message || 'Invalid code. Please try again.');
          }
          accessToken = data.accessToken;
          confirmEmail.textContent = email;
          confirmError.textContent = '';
          showStep('confirm');
        });
      })
      .catch(function (err) {
        otpError.textContent = err.message || 'Something went wrong. Please try again.';
      })
      .finally(function () {
        setLoading(verifyBtn, false, 'Verify code');
      });
  });

  // OTP input: digits only
  otpInput.addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '');
    verifyBtn.disabled = this.value.length < 6;
  });

  // Step 3: Delete
  deleteBtn.addEventListener('click', function () {
    confirmError.textContent = '';
    setLoading(deleteBtn, true, 'Deleting...');

    fetch(SERVER + '/users', {
      method: 'DELETE',
      headers: { 'Authorization': 'Bearer ' + accessToken }
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            throw new Error(data.message || 'Deletion failed. Please contact support.');
          });
        }
        showStep('success');
      })
      .catch(function (err) {
        confirmError.textContent = err.message || 'Something went wrong. Please try again.';
      })
      .finally(function () {
        setLoading(deleteBtn, false, 'Yes, delete my account');
      });
  });

  // Cancel → back to email
  cancelBtn.addEventListener('click', function () {
    accessToken = '';
    otpInput.value = '';
    showStep('email');
  });

  // Back → email step
  backBtn.addEventListener('click', function () {
    otpInput.value = '';
    otpError.textContent = '';
    showStep('email');
  });
})();
